/**
 * Base URL for API. Use REACT_APP_API_URL (e.g. http://localhost:8000).
 * If empty, returns path only (relative URL).
 */
export const getApiUrl = (path) => {
  const envVar = window._env_?.REACT_APP_API_URL || process.env.REACT_APP_API_URL || '';
  const base = envVar.replace(/\/$/, '');
  const p = path.startsWith('/') ? path : `/${path}`;
  return base ? `${base}${p}` : p;
};
